import {FormEvent, useContext, useState} from 'react';
import {Button, Typography, Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import TextForm from './TextForm.tsx';
import DiscountCodeContext from '../contexts/DiscountCodeContext.tsx';
import {IDiscountCode} from '../models/IDiscountCode.ts';

const DiscountCodeForm = () => {
    const {t} = useTranslation();
    const {createDiscountCodeMutation, createError} = useContext(DiscountCodeContext);

    const [discountCode, setDiscountCode] = useState<IDiscountCode>({
        code: '',
        discountPercent: 0,
        expiresAt: new Date(),
    });

    const handleChange = (key: string, value: any) => {
        setDiscountCode(prev => ({
            ...prev,
            [key]: key === 'expiresAt' ? new Date(value) : value,
        }));
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        const payload = {
            ...discountCode,
            expiresAt: discountCode.expiresAt ? new Date(discountCode.expiresAt).toISOString() : null,
        };
        await createDiscountCodeMutation.mutateAsync(payload);
    };

    const formatDate = (date: Date) => {
        return date.toISOString().split('T')[0];
    };

    const formLabels = [
        t('DISCOUNT_CODE'),
        t('DISCOUNT_PERCENT'),
        t('DISCOUNT_EXPIRATION'),
    ];

    const formData = {
        code: {value: discountCode.code, required: true},
        discountPercent: {value: discountCode.discountPercent, required: true, percentage: true},
        expiresAt: {value: formatDate(discountCode.expiresAt), required: true, date: true},
    };

    return (
        <form onSubmit={handleSubmit}>
            <TextForm
                formLabels={formLabels}
                formData={formData}
                formHeader={t('CREATE_DISCOUNT_CODE')}
                onChange={handleChange}
            />

            {createError && (
                <Typography color="error" pl={3}>
                    {createError.message || t('ERROR_CREATING_CODE')}
                </Typography>
            )}

            <Box pl={3} pt={2}>
                <Button type="submit" variant="contained" color="primary">
                    {t('CREATE')}
                </Button>
            </Box>
        </form>
    );
};

export default DiscountCodeForm;
